export const TYPE_FORMATTED_MIXPANEL = {
  posts: 'Video',
  creators: 'Creator',
  topics: 'Topic',
  industry_topic: 'Industry Category',
  global_topic: 'Global Topic',
  theme: 'Theme',
  segment: 'Segment',
  subject: 'Subject',
  entity_query: 'Entity Query',
  entity: 'Entity',
  subtopics: 'Subtopic',
  niches: 'Niche',
  savedPostSearches: 'Saved Search',
  trendings: 'Trending',
  tags: 'Tag',
}
